import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ActionType } from '@ngxs/store';
import { last } from 'lodash-es';
import { switchMap, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoggingContextService {
  private static readonly contextStack: Array<string> = [];

  public static setContext(action: ActionType) {
    LoggingContextService.contextStack.push(action.type);
  }

  public static getContext() {
    return last(LoggingContextService.contextStack);
  }

  public static resetContext() {
    LoggingContextService.contextStack.pop();
  }

  public get context(): string {
    return last(LoggingContextService.contextStack);
  }

  public setContextOperator(action: ActionType): (sourceObservable: Observable<any>) => Observable<any> {
    LoggingContextService.contextStack.push(action.type);
    return (sourceObservable: Observable<any>) => sourceObservable;
  }

  public startLoggedAction(action: ActionType, func: () => Observable<any>): Observable<any> {
    return of({}).pipe(
      this.setContextOperator(action),
      switchMap(func),
      tap(() => LoggingContextService.contextStack.pop()),
    );
  }
}
